<script setup lang="ts">
definePage({
  meta: {
    id: 'capteurs',
    title: 'Capteurs',
    icon: 'mdi-devices',
    drawerIndex: 6,
    breadcrumb: 'disabled',
    requiresAuth: true,
    requiresSiteAccess: 'agri.capteurs'
  },
})
</script>
<template>
  <RouterWrapper />
</template>
